import { useEffect } from 'react'
import { Text, View } from 'react-native'
import Constants from 'expo-constants'
import * as Font from 'expo-font'
import { useTranslation } from 'react-i18next'

import { Logo } from '@/components/icon'

interface SplashScreenProps {
  onFinish: () => void
}

export default function SplashScreen({ onFinish }: SplashScreenProps) {
  const { t } = useTranslation()
  useEffect(() => {
    // Fonts improve the first frame, but they must never keep the app on its
    // splash page. On a cold Android development build the previous promise
    // chain could remain pending long after its intended five-second limit.
    const splashTimer = setTimeout(onFinish, 2_000)

    void Font.loadAsync({
      'Roboto-Regular': require('../../assets/fonts/Roboto-Regular.ttf'),
      'Roboto-Medium': require('../../assets/fonts/Roboto-Medium.ttf'),
      'Roboto-Semibold': require('../../assets/fonts/Roboto-Semibold.ttf'),
      'Roboto-Black': require('../../assets/fonts/Roboto-BlackItalic.ttf')
    }).catch((error) => console.warn('Unable to load bundled fonts', error))

    return () => {
      clearTimeout(splashTimer)
    }
  }, [onFinish])

  return (
    <View className={'bg-background flex-1 items-center justify-center gap-10'}>
      <Logo />
      <View>
        <Text className={'text-sm text-text-primary'}>{t('ui:version', { version: Constants.expoConfig?.version ?? '' })}</Text>
      </View>
    </View>
  )
}
